// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__NszpM","paramInput":"JobSimulator_paramInput__TLc8L","input":"JobSimulator_input__2S3Mk"};